import { render, staticRenderFns } from "./profitTableComponent2.vue?vue&type=template&id=e8c09954&scoped=true"
import script from "./profitTableComponent2.vue?vue&type=script&lang=js"
export * from "./profitTableComponent2.vue?vue&type=script&lang=js"
import style0 from "./profitTableComponent2.vue?vue&type=style&index=0&id=e8c09954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c09954",
  null
  
)

export default component.exports